import { rootReducer } from '../reducers';

export * from './system';
export * from './tableData';
export * from './reseller';
export * from './returnOrder';
export * from './returnTracking';
export * from './returnOrderTracking';
export * from './trackingDetails';
export * from './issueList';
export * from './user';
export * from './managedUsers';
export * from './returnOrderAuditHistory';
export * from './returnOrderList';
export * from './returnOrderProblemShelf';
export * from './asynchronouslyLoadedValue';
export * from './poReviewDraft';
export * from './returnOrderDraft';
export * from './userTermsAndConditionsAcceptance';
export * from './newsPage';
export * from './claimList';
export * from './claim';
export * from './carriers';
export * from './promotion';
export * from './salesOrderDemand';
export * from './extractionList';

export type RootState = ReturnType<typeof rootReducer>;
